import { render, staticRenderFns } from "./establishments-partial.vue?vue&type=template&id=4481a5f2"
import script from "./establishments-partial.vue?vue&type=script&lang=js"
export * from "./establishments-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports